module.exports = __webpack_public_path__ + "img/timeline_miscevent-21.03acc6e7.jpg";